import { apiHandler } from '../api/apihandler';
import { GAME_CATEGORY_LIST } from '../api/constants';

// GAME_CATEGORY_LIST is paginated (10 per page by default) - calling it with
// no params only ever returned the first page, so categories 11+ never
// showed. Ask for large pages and keep following `meta.last_page` until
// every category is loaded.
const PAGE_SIZE = 50;
const MAX_PAGES = 20; // safety stop against a bad `last_page`

export async function fetchAllGameCategories(extraParams = {}) {
   const all = [];
   let page = 1;
   let lastPage = 1;

   do {
      const res = await apiHandler(GAME_CATEGORY_LIST, 'POST', { ...extraParams, page, limit: PAGE_SIZE });
      if (res?.data?.response?.status !== 200) {
         if (page === 1) return null; // first page failed - let the caller decide
         break;
      }
      const payload = res?.data?.data?.data || {};
      const rows = Array.isArray(payload.data) ? payload.data : [];
      all.push(...rows);
      lastPage = Number(payload?.meta?.last_page) || page;
      if (!rows.length) break;
      page += 1;
   } while (page <= lastPage && page <= MAX_PAGES);

   // De-duplicate by id in case pages overlap.
   const seen = new Set();
   return all.filter((category) => {
      const key = category?.id ?? JSON.stringify(category);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
   });
}
